export const motivos = [
    {descripcion:'Queja'},
    {descripcion:'Duda sobre producto'},
    {descripcion:'Otro'}
];